import { UserAccessRoutes, UserPermission, UserProfile } from 'types/authContext';

export const noUserRoutesAccess: UserAccessRoutes = {
    capacityOverview: false,
    manageCapacity: false,
    capacityActionPlan: false,
    recruitmentNeeds: false,
};

const hasCapacityOverviewAccess = (userProfile: UserProfile | null) => !!userProfile?.rolePermissions.includes(UserPermission.VIEW_CAPACITY_OVERVIEW);

const hasManageCapacityAccess = (userProfile: UserProfile | null) => (!!userProfile?.rolePermissions.includes(UserPermission.VIEW_MANAGE_CAPACITY));

const hasActionPlanAccess = (userProfile: UserProfile | null) => (!!userProfile?.rolePermissions.includes(UserPermission.VIEW_ACTION_PLAN));

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const hasRecruitmentNeedsAccess = (userProfile: UserProfile | null) => (!!userProfile?.rolePermissions.includes(UserPermission.VIEW_RECRUITMENT_NEEDS));

/**
 * Handles whether the user, given the current environment and role, has access to each route on the site
 */
export const getAccessRoutes = (userProfile: UserProfile | null): UserAccessRoutes => {
    if (!userProfile) return noUserRoutesAccess;

    return {
        capacityOverview: hasCapacityOverviewAccess(userProfile),
        manageCapacity: hasManageCapacityAccess(userProfile),
        capacityActionPlan: hasActionPlanAccess(userProfile),
        recruitmentNeeds: false, // Disabling RecruitmentNeeds page access
    };
};
